// Übersetzungen auf Deutsch
export const de = {
  common: {
    welcome: "Willkommen",
    logout: "Abmelden",
    login: "Anmelden",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    back: "Zurück",
    next: "Weiter",
    previous: "Vorherige",
    search: "Suchen",
    filter: "Filtern",
    close: "Schließen",
  },
  login: {
    title: "Anmelden",
    subtitle: "Zugriff auf Ihr Auriga-Konto",
    button: "Mit Authentik anmelden",
    checking: "Sitzung wird überprüft...",
    redirecting: "Weiterleitung...",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Willkommen",
    userInfo: "Benutzerinformationen",
    email: "E-Mail",
    id: "ID",
    apiInfo: "API-Informationen",
    noUserData: "Keine Benutzerinformationen verfügbar.",
    sections: "Verfügbare Bereiche",
    qualityDashboard: "Qualitäts-Dashboard",
    maintenanceDashboard: "Wartungs-Dashboard",
    adminDashboard: "Administrations-Dashboard",
    noAccess: "Sie haben keinen Zugriff auf spezialisierte Bereiche. Wenden Sie sich an den Administrator, um Berechtigungen zu erhalten.",
    permissions: "Berechtigungsinformationen",
    factories: "Fabriken",
    roles: "Rollen",
    departments: "Abteilungen",
    groups: "Gruppen",
    none: "Keine",
    noneFound: "Keine",
  },
  quality: {
    title: "Qualitäts-Dashboard",
    permissions: "Berechtigungsinformationen",
    accessChecks: "Zugriffsprüfungen",
    factoryAccess: "Zugriff auf",
    roleIn: "Rolle",
    features: "Qualitätsfunktionen",
    inspections: "Inspektionsverwaltung",
    qualityControl: "Qualitätskontrolle",
    nonConformities: "Berichte über Abweichungen",
    trends: "Trendanalyse",
  },
  maintenance: {
    title: "Wartungs-Dashboard",
    permissions: "Berechtigungsinformationen",
    accessChecks: "Zugriffsprüfungen",
    factoryAccess: "Zugriff auf",
    roleIn: "Rolle",
    features: "Wartungsfunktionen",
    planning: "Wartungsplanung",
    workOrders: "Arbeitsaufträge",
    equipment: "Geräteverwaltung",
    history: "Wartungsverlauf",
  },
  admin: {
    title: "Administrations-Dashboard",
    permissions: "Berechtigungsinformationen",
    accessChecks: "Zugriffsprüfungen",
    group: "Gruppe",
    features: "Verwaltungsfunktionen",
    users: "Benutzerverwaltung",
    system: "Systemkonfiguration",
    reports: "Verwaltungsberichte",
    audit: "Prüfung und Protokolle",
  },
  navigation: {
    dashboards: "Dashboards",
  },
  errors: {
    notAuthenticated: "Nicht authentifiziert",
    accessDenied: "Zugriff verweigert",
    noPermission: "Sie haben keine Berechtigung, auf diesen Bereich zuzugreifen.",
    requirements: "Anforderungen",
    factory: "Fabrik",
    department: "Abteilung",
    role: "Rolle",
    group: "Gruppe",
    backToDashboard: "Zurück zum Dashboard",
  },
};








